import { IBinGroup, IBinGroupData } from './types';

export const normalizeBinGroup = (data: IBinGroupData): IBinGroup => {
  return {
    bins: (data?.bins as string) || '',
    countRulesetsUse: data?.countRulesetsUse as number,
    groupType: (data?.groupType as string) || null,
    id: (data?.id as number) || 0,
    merchant: {
      id: (data?.merchant?.id as number) || 0,
      name: (data?.merchant?.name as string) || '',
    },
    merchantTerminal: {
      id: (data?.merchantTerminal?.id as number) || 0,
      name: (data?.merchantTerminal?.name as string) || '',
    },
    name: (data?.name as string) || '',
  };
};
